import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Currency from 'components/consumer/Currency';
import InfoTooltip from 'components/consumer/InfoTooltip';
import VisuallyHidden from 'components/consumer/VisuallyHidden';

const PDPPriceSectionUI = ({
  price,
  salePrice,
  leastTieredDiscountedPrice,
  maxTieredDiscountedPrice,
  hasDiscount,
  hasTieredDiscount,
  pdpIsModularBYOProduct,
  variant,
}) => (
  <div
    className={classNames(
      'text-lg font-bold text-gray flex items-center lg:text-xl lg:font-bold',
      {
        '!text-base !font-bold !flex-wrap lg:!flex-nowrap':
          variant === 'PDPUpSellProduct',
        'lg:w-1/2': variant === 'PDPUpSellFlyOut',
        '!text-base': variant === 'PDPExtraOptionSelector',
      }
    )}
    data-xc="PDPPriceSection"
  >
    {!!hasDiscount && <VisuallyHidden>Original price:</VisuallyHidden>}

    {price === 0 && pdpIsModularBYOProduct ? (
      <span className="text-base font-bold">Add a piece</span>
    ) : (
      <Currency
        className={classNames({ 'text-gray line-through mr-1.5': hasDiscount })}
      >
        {price}
      </Currency>
    )}

    <InfoTooltip
      withArrow
      modifier="brand-fade"
      openOnHover
      width={250}
      showCloseButton={false}
      iconSize="big"
      className="bottom-px"
      iconClassName={classNames('!mr-2', {
        '!ml-0': hasDiscount,
        '!ml-2': !hasDiscount,
      })}
    >
      <div className="text-xs m-0 normal-case">
        Price is subject to change dependent upon zip code of delivery address
      </div>
    </InfoTooltip>

    {!!hasDiscount && (
      <>
        <VisuallyHidden>Price:</VisuallyHidden>

        <Currency className="text-red">
          {hasTieredDiscount ? maxTieredDiscountedPrice : salePrice}
        </Currency>

        {hasTieredDiscount &&
          leastTieredDiscountedPrice !== maxTieredDiscountedPrice && (
            <>
              <span className="mx-1">-</span>
              <Currency className="text-red">
                {leastTieredDiscountedPrice}
              </Currency>
            </>
          )}

        <span
          className={classNames(
            'text-xs ml-2 text-red flex min-h-[24px] items-center',
            {
              '!flex-wrap !ml-0 lg:!ml-1.5 lg:!flex-nowrap':
                variant === 'PDPUpSellProduct',
              '!ml-1.5': variant === 'PDPExtraOptionSelector',
            }
          )}
        >
          {hasTieredDiscount
            ? `(Save up to $${price - maxTieredDiscountedPrice})`
            : `(Save $${price - salePrice})`}
        </span>
      </>
    )}
  </div>
);

PDPPriceSectionUI.propTypes = {
  price: PropTypes.number,
  salePrice: PropTypes.number,
  leastTieredDiscountedPrice: PropTypes.number,
  maxTieredDiscountedPrice: PropTypes.number,
  hasDiscount: PropTypes.bool,
  hasTieredDiscount: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  variant: PropTypes.oneOf([
    'PDPExtraOptionSelector',
    'PDPUpSellProduct',
    'PDPUpSellFlyOut',
  ]),
};

export default PDPPriceSectionUI;
